import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/es.string.trim.js";
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation } from 'react-router';
import queryparse from 'tricks/string/queryparse';
import config from 'utils/config';
import api from 'utils/api';
import { isHelixOnlyHub } from 'utils/helix';
import { setSuccessAlert, setAlert } from 'actions/alerts';
import Button from 'components/Button';
import Card from 'components/Card';
import Panel from 'components/Panel';
import FormField from 'components/FormField';
import TextArea from 'components/TextArea';
import Modal from 'components/Modal';
import ModalHeadline from 'components/ModalHeadline';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var httpUrlRegEx = /^https?:\/\//i; // starts with http:// or https://

function absoluteUrl(url) {
  if (httpUrlRegEx.test(url)) {
    return url;
  }
  return "".concat(document.location.origin).concat(url);
}
function ContactFormModal(_ref) {
  var _config$customContact;
  var onClose = _ref.onClose;
  var _useTranslation = useTranslation(),
    _useTranslation2 = _slicedToArray(_useTranslation, 1),
    t = _useTranslation2[0];
  var location = useLocation();
  var _useState = useState(''),
    _useState2 = _slicedToArray(_useState, 2),
    message = _useState2[0],
    setMessage = _useState2[1];
  var title = (config === null || config === void 0 || (_config$customContact = config.customContactForm) === null || _config$customContact === void 0 ? void 0 : _config$customContact.title) || t('contact_form_title');
  function submitForm(e) {
    e.preventDefault();
    var searchParams = queryparse(location.search);
    var content = {
      contentId: searchParams.asset,
      // Add the location the contact form was submitted from to the email
      // Note that search parameters (such as `?modal=contact-form` itself) aren't included.
      location: absoluteUrl(location.pathname),
      message: message.trim()
    };
    api('post', '/api/content-request', null, {
      name: title,
      content: content
    }).then(function () {
      setSuccessAlert({
        title: t('alert_contact_form_submit_success')
      });
      onClose();
    }).catch(function (err) {
      setAlert({
        title: t('alert_contact_form_submit_error'),
        message: err === null || err === void 0 ? void 0 : err.error
      });
    });
  }
  var titleId = 'contact-form-title';
  return /*#__PURE__*/_jsx(Modal, {
    id: "contact-form",
    onRequestClose: onClose,
    "aria-labelledby": titleId,
    children: /*#__PURE__*/_jsxs(Card, {
      variant: "raised",
      as: "form",
      id: "contact_modal_form",
      onSubmit: submitForm,
      children: [/*#__PURE__*/_jsx(ModalHeadline, {
        title: title,
        titleId: titleId,
        subtitle: t(isHelixOnlyHub ? 'contact_form_description_helix' : 'contact_form_description'),
        onClose: onClose
      }), /*#__PURE__*/_jsx(Panel, {
        children: /*#__PURE__*/_jsx(FormField, {
          required: true,
          label: "".concat(t('contact_form_your_request'), " *"),
          children: /*#__PURE__*/_jsx(TextArea, {
            "data-autofocus": true,
            value: message,
            onChange: function onChange(e) {
              return setMessage(e.target.value);
            },
            minRows: 3,
            maxRows: 6
          })
        })
      }), /*#__PURE__*/_jsx(Panel, {
        align: "center",
        children: /*#__PURE__*/_jsx(Button, {
          fullWidth: true,
          type: "submit",
          variant: "primary",
          icon: "send",
          isDisabled: message.trim().length === 0,
          children: t('actions_send_request')
        })
      })]
    })
  });
}
export default ContactFormModal;